import React from 'react'
import Trns from 'src/localization/Trns'

export const fileIsEmpty = (val?: File): React.ReactElement | undefined =>
  val === undefined ? <Trns source={'Must not be blank'} /> : undefined
